export const siteContent = {
  company: {
    name: '株式会社アイケーファーム',
    logoAlt: 'IK-FARM ロゴ',
    location: '愛知県西尾市吉良町',
    address: '愛知県西尾市吉良町饗庭西丁畑29-1',
    phone: '0563-77-2059',
    email: 'ikfarm2059@gmail.com',
    instagramUrl: 'https://instagram.com/ikfarm2059',
    youtubeUrl: 'https://www.youtube.com/channel/UCS-NTarDSmQQC14mVEmSqag',
    mapUrl:
      'https://www.google.com/maps/place/%E3%82%A2%E3%82%A4%E3%82%B1%E3%83%BC%E3%83%95%E3%82%A1%E3%83%BC%E3%83%A0/@34.8087016,137.0735941,17z/data=!4m15!1m8!3m7!1s0x6004948c3b1062c9:0x8d7cde3884ec5f7e!2z44CSNDQ0LTA1MjMg5oSb55-l55yM6KW_5bC-5biC5ZCJ6Imv55S66aWX5bqt6KW_5LiB55WR77yS77yZ4oiS77yR!3b1!8m2!3d34.8087016!4d137.0735941!16s%2Fg%2F11bw4d3c22!3m5!1s0x6004948c3b1af605:0xf15d3dd265ad2cde!8m2!3d34.8077338!4d137.0735149!16s%2Fg%2F1tdvk3rk?entry=ttu&g_ep=EgoyMDI1MDcyMC4wIKXMDSoASAFQAw%3D%3D',
    copyright: '© 2025 IK-FARM Inc. All Rights Reserved.'
  },
  nav: [
    { href: '/#about', label: '会社のこと' },
    { href: '/#products', label: '育てているもの' },
    { href: '/#work-daily', label: '日々の作業' },
    { href: '/#company-message', label: '採用情報' },
    { href: '/#contact', label: '連絡先' }
  ],
  hero: {
    locationLabel: '愛知県西尾市吉良町',
    title: '田んぼから、毎日の食卓へ。',
    recruitBadge: 'スタッフ募集中',
    recruitCta: '採用情報を見る'
  },
  sectionTitles: {
    about: '会社のこと',
    products: '育てているもの',
    workDaily: '日々の作業',
    recruitment: '一緒に働く方へ',
    contact: '連絡先',
    companyInfo: '会社情報'
  },
  about: [
    '株式会社アイケーファームは、愛知県西尾市吉良町で米・麦・大豆を育てている農業法人です。',
    '毎年同じように見える田んぼでも、天気、土の乾き方、作物の育ち方は少しずつ違います。その日の状態を見ながら、機械の力も借りて、無理のない良い作業を積み重ねています。'
  ],
  president: {
    title: '代表より',
    imageAlt: '代表',
    message:
      '農業は、予定どおりにいかないことの多い仕事です。だからこそ、畑や田んぼをよく見て、できることを一つずつ丁寧に進めることを大切にしています。食卓に届いたときに「おいしい」と思っていただけるよう、これからも地域の中で作り続けていきます。'
  },
  recruitment: {
    lead: '一緒に働いてくださる方を探しています。',
    paragraphs: [
      '外で体を動かす仕事が好きな方、農業機械に興味がある方、地域に根ざした仕事をしてみたい方。経験の有無よりも、毎日の作業をまじめに続けられることを大切にしています。'
    ],
    points: [
      '仕事内容は、米・麦・大豆の栽培作業と、トラクターやコンバインなど農業機械の運転が中心です',
      '経験や資格は問いません。仕事はひとつずつ丁寧にお教えします',
      '自動操舵やドローンなど、新しい農業の技術にも日々触れられます'
    ],
    termsTitle: '募集要項',
    terms: [
      { label: '雇用形態', value: '正社員（通年）' },
      {
        label: '勤務時間',
        value:
          '8:00〜17:00（休憩1時間）　※種まきや稲刈りの時期は、早出や終わりが遅くなることがあります'
      },
      { label: '給与', value: '経験・能力に応じて決定します' },
      { label: '勤務地', value: '愛知県西尾市吉良町（周辺の圃場へ移動します）' }
    ],
    note: '「いきなり応募はちょっと…」という方は、見学だけでも大歓迎です。お気軽にご連絡ください。',
    ctaEmail: 'メールで問い合わせる',
    ctaInstagram: 'InstagramでDMする'
  },
  contact: {
    message: 'ご相談やお問い合わせは、下記メールアドレスまでご連絡ください。'
  },
  footer: {
    message:
      '仕事のこと、作物のこと、見学のことなど、メールまたはInstagramのDMからご連絡ください。'
  },
  sales: {
    title: '商品販売について',
    message:
      '現在、販売ページを準備しています。ご希望の方はメールまたはInstagramのDMからお問い合わせください。'
  },
  products: {
    salesLinkLabel: '販売について見る'
  }
};
